import { connect } from 'react-redux';
import { GetAppPanelView } from './view';

import {
    trackClickTextAppLink,
    trackClickAppStore,
    trackClickGooglePlay,
    trackClickPhoneField,
    trackTypePhoneNumber,
} from '../eventTracking';


const mapDispatchToProps = {
    trackClickTextAppLink,
    trackClickAppStore,
    trackClickGooglePlay,
    trackClickPhoneField,
    trackTypePhoneNumber,
};

const GetAppPanel = connect(undefined, mapDispatchToProps)(GetAppPanelView);
export default GetAppPanel;
